import React from "react";
import "../cmms.css";

// Estatus del equipo como 4 botones de color (en vez de un select): se ve el
// estado de un vistazo y se cambia con un clic. Compatible con FormItem (value/onChange).
export const COLORES_ESTATUS = {
    1: "#2e9e6b", // Funcional
    2: "#d9962b", // Funcional condicionado
    3: "#d64545", // Danado
    4: "#7a8794", // Baja
};

const OPCIONES = [
    { value: 1, label: "Funcional" },
    { value: 2, label: "Condicionado" },
    { value: 3, label: "Dañado" },
    { value: 4, label: "Baja" },
];

const SelectorEstatusEquipo = ({ value, onChange, disabled }) => (
    <div className="cmms-estatus" role="radiogroup">
        {OPCIONES.map((o) => {
            const activo = value === o.value;
            return (
                <div
                    key={o.value}
                    role="radio"
                    aria-checked={activo}
                    tabIndex={0}
                    className={"cmms-estatus-opcion" + (activo ? " activo" : "")}
                    style={activo ? { background: COLORES_ESTATUS[o.value] } : undefined}
                    onClick={() => !disabled && onChange && onChange(o.value)}
                    onKeyDown={(e) => {
                        if (!disabled && onChange && (e.key === "Enter" || e.key === " ")) {
                            e.preventDefault();
                            onChange(o.value);
                        }
                    }}
                >
                    <span className="cmms-estatus-punto" style={{ background: COLORES_ESTATUS[o.value] }} />
                    {o.label}
                </div>
            );
        })}
    </div>
);

export default SelectorEstatusEquipo;
